import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormularioConductor } from '../clases/formularioConductor';

@Injectable({
  providedIn: 'root'
})
export class FomularioConductorService {

  constructor(
    private _http : HttpClient
  ) { }

  saveFormularioConductor(data:any){
    let url = environment.URL_BASE + 'FomularioConductor/save'
    return this._http.post(url,data);
  }
  exportExcelFormulario(){
    const url = environment.URL_BASE + "OtrosReportesAuthorization/descargarReporteCupones";
    return this._http.get(url, {headers:{}, responseType: "blob" });
  }
  getObtenerTabla(id : number){
   const url = environment.URL_BASE  + "FomularioConductor/ObtenerTablaGenerica?id=" + id
    return this._http.get(url)
  }
}
